import NavBar from "../components/Navbar/NavBar";
import { NotFound } from "../components/NotFound";


export default function Error404() {
  return (
    <>
        <NavBar />
        <NotFound />
    </>
  );
}
